<template>
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="size" :height="size" viewBox="0 0 50 50" v-on="$listeners">
    <g id="Pen_" data-name="Pen " >
        <g id="noun_Pen_1047181" transform="translate(1.504 4.845)">
        <g id="Groupe_2849" data-name="Groupe 2849" transform="translate(11.325 5.995)">
            <path id="Tracé_2952" data-name="Tracé 2952" d="M31.274,958.357a3.2,3.2,0,0,1,2.269.9l2.13,2.12a.659.659,0,0,1,0,.9c-6.482,6.463-12.685,12.675-19.422,19.412a2.358,2.358,0,0,1-1.576.684,1.857,1.857,0,0,1-1.526.188l-.9.476a.634.634,0,0,1-.852-.862l.466-.892a1.86,1.86,0,0,1,.188-1.536,2.373,2.373,0,0,1,.684-1.575l12.9-12.9,4.172-4.172a.621.621,0,0,1,.892,0l2.18,2.179,1.447-1.457-1.685-1.674a2.034,2.034,0,0,0-1.784-.5,4.07,4.07,0,0,0-2.249,1.179l-4.459,4.459a.634.634,0,1,1-.892-.9l4.449-4.449a5.306,5.306,0,0,1,2.973-1.546,4.1,4.1,0,0,1,.595-.039Zm-1.021,4.092-3.726,3.726-12.892,12.9a1.086,1.086,0,0,0-.317.843.642.642,0,0,1-.149.436.6.6,0,0,0-.05.664.634.634,0,0,1,.069.218.641.641,0,0,1,.218.069.6.6,0,0,0,.664-.05.64.64,0,0,1,.446-.149,1.081,1.081,0,0,0,.842-.307l12.892-12.9,3.726-3.726Z" transform="translate(-11.325 -958.357)" :fill="color" :stroke="color" stroke-width="0.5" fill-rule="evenodd"/>
            <path id="Tracé_2953" data-name="Tracé 2953" d="M36.63,1033.257a.634.634,0,1,1,0,1.268H29.122a.634.634,0,1,1,0-1.268Z" transform="translate(-23.045 -1009.507)" :fill="color" :stroke="color" stroke-width="0.5" fill-rule="evenodd"/>
            <path id="Tracé_2954" data-name="Tracé 2954" d="M27.616,1042.367a.634.634,0,1,1,0,1.268H12.6a.634.634,0,1,1,0-1.268Z" transform="translate(-11.764 -1015.729)" :fill="color" :stroke="color" stroke-width="0.5" fill-rule="evenodd"/>
        </g>
        </g>
    </g>
    </svg>
</template>
<script>
import { Colorable, Sizeable } from '../../mixins';

export default {
    name: 'IconPen',
    mixins: [Colorable, Sizeable],
};
</script>

